const DELETED_ACCOUNT_LABEL = 'Deleted Account';

export function isDeletedAccountUsername(username?: string | null): boolean {
  return Boolean(username?.toLowerCase().startsWith('deleted'));
}

export function getDisplayUsername(username?: string | null): string | undefined {
  if (!username) return undefined;

  return isDeletedAccountUsername(username) ? DELETED_ACCOUNT_LABEL : username;
}

export { DELETED_ACCOUNT_LABEL };
